import { Pipe, PipeTransform } from '@angular/core';

/* eslint-disable no-useless-escape */
@Pipe({
  name: 'stavZpochybneni',
  standalone: true,
})
export class StavZpochybneniPipe implements PipeTransform {
  transform(value: string | undefined): string {
    if (!value) {
      return '';
    }
    if (value === 'NEDEFINOVANY') {
      return 'Správnost údaje: Nedefinovaný';
    }
    if (value === 'NESPRAVNY') {
      return 'Správnost údaje: Nesprávný';
    }
    if (value === 'NESPRAVNY_TVAR') {
      return 'Správnost údaje: Nesprávný tvar';
    }
    return '';
  }
}
